import DollarIcon from './DollarIcon';

export default DollarIcon;
